module.exports = "/participant@2x-8014b7219ec7b94c234655d9dec40fea.png";